'use strict';

angular.module('quantixApp').
    directive('peerGroups', [function () {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/directive/peerGroup/peerGroup.html'
        }
    }]);